var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z",
    stroke: "#313131",
    strokeWidth: 0.833333
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_821_27308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4571 4.33398V12.4116C12.2555 11.6131 13.0476 10.8208 13.833 10.0354C14.0632 10.2653 14.2742 10.4765 14.4788 10.6812C13.3237 11.8362 12.1596 13.0004 11.0022 14.1577C9.84469 13.0001 8.68053 11.836 7.52344 10.6786C7.72715 10.4754 7.93838 10.2644 8.15234 10.0511C8.93734 10.8361 9.72894 11.6277 10.5458 12.4448V4.33398H11.4573H11.4571Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16797 15.0898H16.8346V16.0013H5.16797C5.16797 15.6976 5.16797 15.3936 5.16797 15.0898Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_821_27308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.6667,
    height: 11.6667,
    fill: "white",
    transform: "translate(5.16797 4.33398)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.ab30b46a9c0e91f9051032887534368f.svg";
export { ForwardRef as ReactComponent };